const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg-grayscale-xx-light w-[calc(100vw_-_210px)]">
      {children}
    </div>
  );
};

export default PageWrapper;
